import React from "react";
import { ShoppingGallery } from "./finish-shopping-gallery";
import SortBar from "./sort-bar";
import { cloneData } from "../../../library/utils/clone";
import { sortByProperty } from "../../functions/sort-by-property";
import { InfiniteScrollComponent } from "../../../library/components/components";
import LoadingIndicator from "../loading/loading-indicator";
import GallerySearchBar from "./gallery-search-bar";
import { parseFiltersFromUrl, writeFiltersToUrl, subscribePopstate } from "../../functions/filter-url-state";

// Finish gallery has no filter bar — only sort + find round-trip the URL.
var URL_SCHEMA = { sort: 'string', find: 'string' };


class Gallery extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let data = this.props.data;
        let count = data.length;
        let countLabel = count === 1 ? "item" : "items";
        let displayCount = this.props.pagedData.length;
        return (
            <div>
                <div className="gallery-grid" ref={(ref) => this.galleryGrid = ref}>
                    <div className="gallery-items-container">
                        <div className="filters-header-container">
                            <div className="filters-bar-container">
                            </div>
                            <div className="gallery-items-count">
                                <GallerySearchBar
                                    key={"gsb-" + (this.props.urlVersion || 0)}
                                    onSubmitSearch={this.props.onSubmitSearch}
                                    initialValue={this.props.searchTerm || ""}
                                />
                                <SortBar
                                    key={"sb-" + (this.props.urlVersion || 0)}
                                    onSortChange={this.props.onSortChange}
                                    excludePriceSort={true}
                                    defaultSort={this.props.currentSort || null}
                                />
                                <span className="count-label">{displayCount}&nbsp;of&nbsp;{count}&nbsp;{countLabel}</span>
                            </div>
                        </div>
                        <div className="gallery-items-list">
                            <ShoppingGallery
                                data={this.props.pagedData}
                                baseImageUrl={this.props.baseImageUrl}
                                onLike={this.props.onLike}
                            />
                            {count < 1 &&
                                <div className="gallery-no-results">
                                    No items match your filter criteria. Please adjust your filters and try again.
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {this.props.showLoader &&
                    <LoadingIndicator />
                }
            </div>

        );

    }
}

class BaseGalleryComponent extends InfiniteScrollComponent {
    constructor(props) {
        super(props)
        this.yBottom = 500;
        let data = props.data || [];
        let dataCopy = cloneData(data);
        let N=100;
        let pagedData=data.slice(0,N);
        this.throttleScroll = false;
        this.state = {
            pagedData:pagedData,
            page:1,
            N:N,
            maxPage:this.maxPage(data,N),
            originalMaxPage:this.maxPage(data,N),
            data: data,
            filteredDataCopy:data,
            dataCopy: dataCopy,
            sortBy:null,
            showLoader: false,
            searchTerm:'',
            urlVersion: 0
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.galleryGrid = document.querySelector(".gallery-grid");
        this.applyUrlState();
        this._popstateUnsub = subscribePopstate(this.onPopstate);
    }

    componentWillUnmount() {
        if (typeof super.componentWillUnmount === 'function') super.componentWillUnmount();
        if (this._popstateUnsub) { this._popstateUnsub(); this._popstateUnsub = null; }
    }

    onPopstate = () => { this.applyUrlState({ bumpVersion: true }); }

    applyUrlState = (opts) => {
        var parsed = parseFiltersFromUrl(URL_SCHEMA);
        var sortBy = parsed.sort || null;
        var find = parsed.find || '';
        if (!sortBy && !find) {
            if (opts && opts.bumpVersion) {
                this.setState({ urlVersion: (this.state.urlVersion || 0) + 1 });
            }
            return;
        }
        var filtered = (this.state.dataCopy || []).slice();
        var activeSort = sortBy || this.state.sortBy;
        if (activeSort) filtered = this.sortData(filtered, activeSort);
        var filteredDataCopy = cloneData(filtered);
        if (find) {
            var self = this;
            filtered = filtered.filter(function (p) { return self.matchesSearch(p, find); });
        }
        var paged = filtered.slice(0, this.state.N);
        var nextState = {
            pagedData: paged,
            data: filtered,
            filteredDataCopy: filteredDataCopy,
            page: 1,
            maxPage: this.maxPage(filtered, this.state.N),
            sortBy: activeSort,
            searchTerm: find
        };
        nextState.urlVersion = (this.state.urlVersion || 0) + 1;
        this.setState(nextState);
    }

    syncUrl = (overrides) => {
        var sortBy = (overrides && overrides.sortBy != null) ? overrides.sortBy : this.state.sortBy;
        var searchTerm = (overrides && typeof overrides.searchTerm === 'string') ? overrides.searchTerm : (this.state.searchTerm || '');
        var urlState = {};
        if (sortBy) urlState.sort = sortBy;
        if (searchTerm) urlState.find = searchTerm;
        writeFiltersToUrl(urlState, URL_SCHEMA);
    }

    maxPage=(data,N)=>{
        return Math.ceil(data.length / N);
    }

    sortData=(data,sortBy)=>{
        let val = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        if (!val) return data;
        let params = val.split("|");
        let sortField = params[0];
        let sortDirection = params[1];
        let sortedData = sortByProperty(data, sortField, sortDirection);
        return sortedData;
    }

    onSortChange = (sortBy) => {
        let val = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        let sortedData = this.sortData(this.state.data, val);
        let pagedData=sortedData.slice(0,this.state.N);
        this.setState({ data: sortedData,
            filteredDataCopy: sortedData,
            pagedData: pagedData,
            sortBy: val
        });
        this.syncUrl({ sortBy: val });
    }

    rebind=()=>{
        let nextPage=this.state.page+1;
        let pagedData=this.state.data.slice(0,this.state.N*nextPage);
        this.setState({
            pagedData: pagedData,
            page: nextPage,
            showLoader: false
        },()=>{
            this.throttleScroll = false;
        });

    }

    onScroll() {
        super.onScroll();
        if (!this.throttleScroll) {
            this.throttleScroll = true;
            if (this.state.page < this.state.maxPage) {
                this.setState({ showLoader: true },()=>{
                    setTimeout(() => {
                        this.rebind();
                    }, 1000);
                });
            }
        }
    }

    onSubmitSearch = (value) => {
        var trimmed = value ? value.trim() : '';
        if(!trimmed){
            let data=this.state.filteredDataCopy;
            let pagedData=data.slice(0,this.state.N);
            this.setState({
                pagedData: pagedData,
                data: data,
                page:1,
                maxPage:this.maxPage(pagedData,this.state.N),
                searchTerm:''
            });
            this.syncUrl({ searchTerm: '' });
            return;
        }else{
            let data = this.state.filteredDataCopy;
            let filtered = data.filter(product => this.matchesSearch(product, trimmed));
            let pagedData=filtered.slice(0,this.state.N);
            this.setState({
                data: filtered,
                pagedData: pagedData,
                page:1,
                maxPage:this.maxPage(filtered,this.state.N),
                searchTerm: trimmed
            });
            this.syncUrl({ searchTerm: trimmed });
        }
    }

    matchesSearch(product, query) {
        if (!query) return true;

        const q = query.trim().toLowerCase();
        if (!q) return true;

        const sku = (product.sku || "").toLowerCase();
        const name = (product.name || "").toLowerCase();
        const subOptionCode = (product.subOptionCode || "").toLowerCase();

        if (q.length === 1) {
            return sku.startsWith(q) || name.startsWith(q);
        }

        return sku.indexOf(q) !== -1 || name.indexOf(q) !== -1 || subOptionCode.indexOf(q) !== -1;
    }
}

export class FinishGalleryComponent extends BaseGalleryComponent {

    onLike = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent('favorite-add', {
            detail: {
                itemType: 'Finish',
                sku: item.sku,
                name: item.name || item.sku,
                image: this.props.baseImageUrl + '/' + item.image + '?width=500',
                collection: item.subOptionCode || '',
                link: '/Custom-Option/Finish/Detail/' + encodeURIComponent(item.sku),
                price: ''
            }
        }));
    }

    render() {

        return <Gallery
            data={this.state.data}
            pagedData={this.state.pagedData}
            baseImageUrl={this.props.baseImageUrl}
            onSortChange={this.onSortChange}
            showLoader={this.state.showLoader}
            onSubmitSearch={this.onSubmitSearch}
            urlVersion={this.state.urlVersion}
            currentSort={this.state.sortBy}
            searchTerm={this.state.searchTerm}
            onLike={this.onLike}
        />
    }
}
